import { SequenceManagerAction } from "./SequenceManagerAction";
import { ValidateSimApi } from '../api/api';

const EnterSIMIDDetailsAction = {
  SAVE_SIMID_DETAILS: "SAVE_SIMID_DETAILS",
  VALIDATE_SIM_SUCCESS: "VALIDATE_SIM_SUCCESS",
  VALIDATE_SIM_FAILURE: "VALIDATE_SIM_FAILURE"
}

const win: any = window;
const retryCount = win['AllowedAPIRetryCount'];

let validatedSimCounter = 0;

const SimValidation = (serialNumber: any, puk1Number: any) => {
  return function (dispatch: any) {
    ValidateSimApi(serialNumber, puk1Number)
      .then((response) => {
        dispatch({ type: EnterSIMIDDetailsAction.VALIDATE_SIM_SUCCESS, payload: response });
      })
      .catch((error) => {
        //Display error
        if (error?.response?.status) {
          if (error?.response?.status === 401) {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          } else {
            dispatch({ type: EnterSIMIDDetailsAction.VALIDATE_SIM_FAILURE, payload: error?.response });
          }
        } else {
          ++validatedSimCounter
          if (validatedSimCounter < retryCount) {
            const objData = JSON.parse(error?.config?.data);
            const { SIMNumber, PUK1 } = objData;
            dispatch(ValidateSimApi(SIMNumber, PUK1));
          } else {
            dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
          }

        }
      })
  }
}

const saveSimIdDetails = (simNumber: any, puk1Number: any, validateSimResponse: any, offerContainerId: any) => {
  return function (dispatch: any) {
    dispatch({ type: EnterSIMIDDetailsAction.SAVE_SIMID_DETAILS, payload: { simNumber: simNumber, puk1Number: puk1Number, validateSimResponse: validateSimResponse, offerContainerId: offerContainerId } });
    dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['EnterSIMIDDetails'] });
  };
};

export { EnterSIMIDDetailsAction, saveSimIdDetails, SimValidation };